import { Skeleton } from 'shared/components/skeleton'

import styles from './SkeletonLoader.module.scss'

interface IProps {
  cols: number
}

export const SkeletonLoader = ({ cols }: IProps) => {
  return (
    <div className={styles.root}>
      {new Array(cols).fill(0).map((_, index) => (
        <div key={index} className={styles.col}>
          <Skeleton height={32} className={styles.header} />
          <Skeleton height={270} />
        </div>
      ))}
    </div>
  )
}
